import apiCalendarPlan from '@/api/calendar-plan'

const state = {
  error: null,
  isSubmitting: false
}

export const mutationTypes = {
  deleteCalendarPlanStart: '[delete calendar plan] Delete calendar plan start',
  deleteCalendarPlanSuccess:
    '[delete calendar plan] Delete calendar plan success',
  deleteCalendarPlanFailure:
    '[delete calendar plan] Delete calendar plan failure'
}

export const actionTypes = {
  deleteCalendarPlan: '[delete calendar plan] Delete calendar plan'
}

const mutations = {
  [mutationTypes.deleteCalendarPlanStart](state) {
    state.isSubmitting = true
  },

  [mutationTypes.deleteCalendarPlanSuccess](state) {
    state.isSubmitting = false
  },

  [mutationTypes.deleteCalendarPlanFailure](state, payload) {
    state.error = payload
    state.isSubmitting = false
  }
}

const actions = {
  [actionTypes.deleteCalendarPlan](context, {id}) {
    context.commit(mutationTypes.deleteCalendarPlanStart)
    return new Promise(resolve => {
      apiCalendarPlan
        .deleteCalendarPlan(id)
        .then(response => {
          context.commit(mutationTypes.deleteCalendarPlanSuccess)
          resolve(response.data)
        })
        .catch(resolve => {
          context.commit(
            mutationTypes.deleteCalendarPlanFailure,
            resolve.response.data.errors
          )
        })
    })
  }
}

export default {
  state,
  mutations,
  actions
}
